module.exports = __webpack_public_path__ + "assets/img/247501.0cd9792e.png";